module.exports = __webpack_public_path__ + "static/slider-example-8053d1947573916c0d13de0e188f83fc.png";